import { forwardRef } from "react";

import Icon from "@/components/Icon";
import RawCheckCircleFilled from "./RawCheckCircleFilled.svg.jsx";

const CheckCircleFilled = forwardRef((props, ref) => {
  return (
    <Icon
      ref={ref}
      SvgComponent={RawCheckCircleFilled}
      title="Check circle filled icon"
      {...props}
    />
  );
});

export default CheckCircleFilled;
